import { render } from "./PrescriberTwoFactorDisableAuth.vue?vue&type=template&id=12e6df50&scoped=true"
import script from "./PrescriberTwoFactorDisableAuth.vue?vue&type=script&lang=js"
export * from "./PrescriberTwoFactorDisableAuth.vue?vue&type=script&lang=js"

import "./PrescriberTwoFactorDisableAuth.vue?vue&type=style&index=0&id=12e6df50&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e6df50"]])

export default __exports__